import { CommercialItemValidationResponse } from '../../models/commercial-item-validation-response.model';
import { SalesCatalogue } from '../../models/sales-catalogue.model';

export class SalesCatalogueAccountRule {
    constructor(public accountSalesCatalogueCodes: any) { }

    validateAccountLinkedSalesCatalogue(salesCatalogueCodes: string[]): CommercialItemValidationResponse {
        const validSalesCatalogue = this.accountSalesCatalogueCodes?.salesCatalogues?.filter
            (x => salesCatalogueCodes.includes(x.code));

        return {
            data: validSalesCatalogue?.map(x => x.salesCatalogueCode),
            isValid: validSalesCatalogue !== undefined && validSalesCatalogue.length > 0,
        };
    }
}
